import { BadgeCheck } from "lucide-react";

/** "SolSpur Verified" pill — only when every core trust check passes. */
export default function VerifiedBadge({ coin, compact = false }) {
  if (!coin?.trust?.verified) return null;
  return (
    <span
      data-testid="verified-badge"
      title="SolSpur Verified: mint + freeze authority revoked, Raydium pool verified on-chain, whitepaper on file, creator linked X."
      className={`inline-flex items-center gap-1 bg-[#00ff41] text-[#050505] uppercase tracking-widest font-mono font-bold ${
        compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"
      }`}
    >
      <BadgeCheck size={compact ? 9 : 11} /> Verified
    </span>
  );
}
